import { useState } from 'react'
import httpClient from '../config/http.client'
import { AUTHENTICATE } from '../constants/links'
import { UNAUTHORIZED } from '../constants/http.codes'
import { STATE_LOADING } from '../constants/button.states'
import redirect from '../utils/redirect'

const useMFA = ({ invalidCodeErrorMessage, genericErrorMessage }) => {
  const [code, setCode] = useState('')
  const [showError, setShowError] = useState(false)
  const [verifyButtonState, setVerifyButtonState] = useState(undefined)
  const [disabledForm, setDisabledForm] = useState(false)
  const [errorMessage, setErrorMessage] = useState(undefined)

  const isVerifyButtonDisabled = () => disabledForm || !code

  const handleCodeChange = (event) => setCode(event.target.value)

  const handleError = (message) => {
    setCode('')
    setShowError(true)
    setErrorMessage(message)
  }

  const doLogin = (csrf, credentials, mfa) => {
    setVerifyButtonState(STATE_LOADING)
    setDisabledForm(true)

    const data = {
      _csrf: csrf.token,
      mfa: JSON.stringify(mfa),
      username: credentials.username,
      password: credentials.password,
    }

    httpClient
      .post(AUTHENTICATE, new URLSearchParams(data).toString())
      .then((response) => {
        redirect(response.data.redirect_uri)
      })
      .catch((error) => {
        const { response } = error
        if (response?.status === UNAUTHORIZED) {
          handleError(invalidCodeErrorMessage())
        } else {
          handleError(genericErrorMessage ? genericErrorMessage() : undefined)
        }
        setVerifyButtonState(null)
        setDisabledForm(false)
      })
  }

  return {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin,
  }
}

export default useMFA
